import React from 'react';
import { Person } from 'nekst-api';
import { IconButton, IconType, ImageWidget } from 'features/nekst-widgets';

import styles from '../AvatarInput.module.scss';
import { useAvatarPopups } from './useAvatarPopups';

interface AvatarInputLayoutWebProps {
  person: Person;
}

export function AvatarInputLayoutWeb(props: AvatarInputLayoutWebProps) {
  const existingAvatarUrl = props.person.profile._avatarUrl;

  const form = useAvatarPopups();

  let component: React.ReactNode;

  if (existingAvatarUrl) {
    component = (
      <>
        <ImageWidget src={existingAvatarUrl.full} alt="Avatar" className={styles.existingAvatar} />
        <IconButton
          onClick={() => form.openConfirmDeletePopup(props.person.id)}
          type={IconType.X}
          className={styles.deleteButton}
          title="Delete Avatar"
        />
      </>
    );
  } else {
    component = (
      <div className={styles.noAvatarBlock}>
        <div className={styles.image}>&nbsp;</div>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      {component}
      <div className={styles.overlay}>
        <button
          className={styles.uploadPhotoButton}
          type="button"
          onClick={() => form.openUploadForm(props.person.id)}
        >
          &nbsp;
        </button>
      </div>
    </div>
  );
}
